// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3gt_Z","header":"ClearentDisclaimer_header__j7pjL","inner":"ClearentDisclaimer_inner__1pZeU"};